<mat-stepper #stepper [selectedIndex]="0" [formGroup]="questionnaireForm" [animationDuration]="'0'">
  <ng-container formArrayName="pages">
    @for (page of questionnairePages; track page; let pageIndex = $index) {
      <mat-step [formArrayName]="pageIndex" [stepControl]="questionnaireForm.controls.pages.controls[pageIndex]">
        <div class="questions-container">
          @for (question of page.entries; track question; let questionIndex = $index) {
            <div>
              <dt-questionaire-question [question]="question" [formIndex]="questionIndex"></dt-questionaire-question>
            </div>
          }
        </div>
        <div class="navigation-container">
          @if (stepper.selectedIndex === 0) {
            <button mat-raised-button (click)="openStatus.emit()" i18n>Zurück zur Übersicht</button>
          } @else {
            <button mat-raised-button matStepperPrevious color="accent" i18n>Zurück</button>
          }
          @if (stepper.selectedIndex === stepper.steps.length - 1) {
            <button mat-raised-button (click)="openStatus.emit()" i18n>Weiter zur Übersicht</button>
          } @else {
            <button mat-raised-button matStepperNext color="accent" i18n>Weiter</button>
          }
        </div>
      </mat-step>
    }
  </ng-container>
</mat-stepper>
